export { default as MovieListing } from "./movieListing";
